import {t} from 'i18next';
import {CustomDownloadFileDialog} from '../CustomDownloadFileDialog/CustomDownloadFileDialog';

/**
 * Configuration for the DownloadFileDialog that includes the actions to be executed on confirm and cancel
 */
export interface DownloadFileProps {
    readonly title: string;
    readonly headline: string;
    readonly infoText: string;
    onCancel: () => void;
    onConfirm: () => void;
}

/**
 * A warn dialog to inform the user they are about disclaimer data related to file and give consent.
 * @param props dialog props that includes the method for the confirm and cancel methods
 */
export const DownloadFileDialog: React.VFC<DownloadFileProps> = (props) => {
    return (
        <CustomDownloadFileDialog
            data-testid='DownloadFileDialog'
            modal
            open
            title={props.title}
            headline={props.headline}
            onCancel={props.onCancel}
            cancelLabel={t('GENERAL_CANCEL_LABEL')}
            confirmLabel={t('GENERAL_UNDERSTOOD_LABEL')}
            onConfirm={props.onConfirm}
            variant={'warning'}
        >
            {props.infoText}
        </CustomDownloadFileDialog>
    );
};
